import React from 'react'
import CenterQuote from '../components/styled/centerQuote'
import Header from '../components/homepage/Header'
import CenterImg from '../components/styled/centerImg'


const TimeTable = () => {

  return (
    <>
      <Header />
      <CenterQuote text={'Sep - Dec 2026 Time Table '}/>
      <CenterImg url={'https://res.cloudinary.com/dl4murstw/image/upload/v1782319942/HGE%20Course%20Assets/timetable1_yb7puy.jpg'}/>
      <CenterImg url={'https://res.cloudinary.com/dl4murstw/image/upload/v1782319942/HGE%20Course%20Assets/timetable2_duhxwy.jpg'}/>
    </>

  )
}

export default TimeTable